const r = () => Math.floor(Math.random() * Date.now()).toString(16), n = () => `#${Math.floor(Math.random() * 16777215).toString(16)}`, a = (t, o) => (t = Math.ceil(t), o = Math.floor(o), Math.floor(Math.random() * (o - t + 1)) + t);
export {
  r as generateEntityId,
  n as generateRandomColor,
  a as getRandomIntInRange
};
